import { render, staticRenderFns } from "./AdminAnalyticsDownloadsScreen.vue?vue&type=template&id=8d45572e&scoped=true&"
import script from "./AdminAnalyticsDownloadsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminAnalyticsDownloadsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d45572e",
  null
  
)

export default component.exports